module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon1.31a4433c.svg";